import React, { useEffect, useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import { docStatusEnum, documentTypeEnum, messageTypeEnum, tipoImpresionEnum } from '../../enum';
import { dateFormat, generateToken, IsNotNullOrEmptyOrUndefined, validarEmail } from '../../util';
import ProfileDisplay from '../profile/ProfileDisplay';
import Encabezado from '../documentoElectronico/Encabezado';
import Detalle from '../documentoElectronico/Detalle';

import { accionesFactura, tipoDocumento } from '../../catalogos';
import { Dropdown } from 'semantic-ui-react';
import { duplicarFactura } from '../../actions';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import RenderResumenDocumento from '../shared/RenderResumenDocumento';
import { reenviarDocumento, clearErrors } from '../../actions';
import { Container } from 'semantic-ui-react';

import { Button, Modal } from 'semantic-ui-react'
import configFile from "../../apis/configFile.json";
import BasicMessage from '../messages/basicMessage';

let infoCliente = {
  nombreTemp: null,
  emailTemp: null,
  ClaveTemp: null
}

const ListadoDocumentos = (props) => {

  const history = useHistory();

  const { documentos, docType, errorState } = props;
  const [activeIndex, setActiveIndex] = useState(-1);
  const [acciones, setAcciones] = useState(null);
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [message, setMessage] = useState('');
  const [mgType, setMgType] = useState('');
  const [email, setEmail] = useState('na');
  const [emailError, setEmailError] = useState(null);
  let className = '';

  useEffect(() => {
    getAccionesFactura();
    return () => {
      setAcciones(null);
    }
  }, []);

  useEffect(() => {
    if (errorState && errorState.error !== null) {
      setMgType(errorState?.error ? messageTypeEnum.error : messageTypeEnum.success);
      setMessage(errorState.message);
    }
    else {
      setMgType('');
    }
  }, [errorState]);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex);
  }

  const msgSuccess = () => {
    setMgType(messageTypeEnum.success);
    setMessage('La descarga del documento está siendo procesada');
  }

  const handleDropdown = (item, action) => {
    props.duplicarFactura(item);
    let token = generateToken(item.Clave).substring(0, 15);
    switch (action.value) {
      case "01":
        msgSuccess();
        window.open(configFile.agileBillingServicesURL + '/ConsultarFactura/GetPdf/?clave=' + item.Clave + '&token=' + token, "_blank");
        return false;
      case "02":
        msgSuccess();
        window.open(configFile.agileBillingServicesURL + '/consultarFactura/GetXml/?clave=' + item.Clave + '&token=' + token, "_blank");
        return false;
      case "03":
        msgSuccess();
        window.open(configFile.agileBillingServicesURL + '/ConsultarFactura/GetRespuestaXml/?clave=' + item.Clave + '&token=' + token, "_blank");
        return false;
      case "04":
        infoCliente.emailTemp = item.Receptor.CorreoElectronico;
        infoCliente.nombreTemp = item.Receptor.Nombre;
        infoCliente.Clave = item.Clave;
        setIsActiveModal(true)
        break;
      case "05":
        if (docType === '01') {
          history.push(`/crearfactura`);
        }
        if (docType === '03') {
          history.push(`/crearnotacredito`);
        }
        if (docType === '02') {
          history.push(`/crearnotadebito`);
        }
        if (docType === '04') {
          history.push(`/creartiquete`);
        }
        break;
      case "06":
        history.push(`/crearnotacredito`);
        break;
      case "07":
        history.push(`/crearnotadebito`);
        break;
      case "08":
        history.push(`/imprimirdocumento/${tipoImpresionEnum.Carta}`);
        break;
      case "09":
        history.push(`/imprimirdocumento/${tipoImpresionEnum.Tiquete}`);
        break;

      default:
        break;
    }

  }

  const getAccionesFactura = () => {

    if (docType === '04') {
      var acciones = accionesFactura.filter(function (action) {
        return action.value !== '04';
      });
      setAcciones(acciones);

    } else {
      var acciones = accionesFactura.map(function (action) {
        return action;
      });
      setAcciones(acciones)
    }

  }

  const renderDropdown = (item) => {
    return (
      <>
        <Dropdown text='Acciones' direction='left'>
          <Dropdown.Menu>
            {
              acciones.map(action => (
                <Dropdown.Item
                  key={action.value}
                  onClick={() => handleDropdown(item, action)}>
                  {action.display}
                </Dropdown.Item>
              ))
            }
          </Dropdown.Menu>
        </Dropdown>
      </>
    )
  }

  const renderTitle = (item) => {
    const consecutivo = item.NumeroConsecutivo.slice(10, 20);
    const notaCredito = item.ClaveNotaCredito?.length > 0 ? `NC - ${item.ClaveNotaCredito[0].slice(32,41)}` : null;

    switch (item.Estado) {
      case docStatusEnum.aceptado:
        className = 'aceptado';
        break;
       case docStatusEnum.AceptadoHacienda:
        className = 'aceptado';
        break;
      case docStatusEnum.rechazado:
        className = 'rechazado';
        break;
      case docStatusEnum.procesando:
        className = 'procesando';
        break;
      default:
        className = 'rechazado';
        break;
    }

    return (
      <>
        <div className="ui stackable row grid desktop">
          <div className="six wide column">
            <div className="row">
              <div className="sixteen wide">
                <Icon name='dropdown' />
                <span className="header-title">Consecutivo:</span>
              </div>
              <div className="sixteen wide">
                <span className={className}>{`# ${consecutivo} - ${item.Estado}`}</span>
                {notaCredito && <span className='procesando'> - {notaCredito}</span>}
              </div>
            </div>
          </div>

          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Fecha:</span>
              </div>
              <div className="sixteen wide">
                <span>{dateFormat(item.FechaEmision)}</span>
              </div>
            </div>
          </div>


          <div className="three wide column">
            <div className="row">
              {
                (props?.docType !== '04') && (
                  <div>
                    <div className="sixteen wide">
                      <span className="header-title">Nombre:</span>
                    </div>
                    <div className="sixteen wide">
                      <span>{item.Receptor?.Nombre}</span>
                    </div>
                  </div>
                )
              }
            </div>
          </div>


          <div className="four wide column dropdown-actions">
            {renderDropdown(item)}
          </div>

        </div>

        <div className="ui stackable row grid responsive">

          <div className="doubling three column row">
            <div className="column">
              <Icon name='dropdown' />
              <span className={className}>{item.Estado}</span>
            </div>
            <div className="column" style={{ textAlign: "right" }}>
              {renderDropdown(item)}
            </div>
          </div>

          <div className="sixteen wide column">
            <span>{`Consecutivo: ${consecutivo}`}</span>
          </div>

          <div className="sixteen wide column">
            <span>{`Fecha: ${dateFormat(item.FechaEmision)}`}</span>
          </div>

          <div className="sixteen wide column">
            {(props?.docType !== '04') && (
              <span>Nombre: {item.Receptor?.Nombre}</span>
            )}

          </div>

        </div>
      </>
    );
  }

  const closeMessage = () => {
    props.clearErrors();
  }

  const handleInputEmail = (value) => {
    setEmailError(null);
    setEmail(value);
  }

  const handleSubmit = () => {

    if (validarEmail(email) || email === 'na' || !IsNotNullOrEmptyOrUndefined(email)) {
      props.reenviarDocumento(props.token, email, infoCliente.Clave);
      setIsActiveModal(false);
    } else {
      setEmailError('El correo no es valido');
    }

  }

  return (

    <div className="ui listado-documentos-section">

      <div className="container" style={{ marginBottom: "10px" }}>
        <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />
      </div>

      <Accordion fluid styled>
        {
          documentos.map((item, index) => (
            <div key={index}>
              <Accordion.Title
                active={activeIndex === index}
                index={index}
                onClick={handleClick}>
                {renderTitle(item)}
              </Accordion.Title>
              <Accordion.Content active={activeIndex === index}>
                <div className="ui segment accordion-content">

                  {
                    docType !== documentTypeEnum.Tiquete && docType !== documentTypeEnum.FacturaCompra && (
                      <ProfileDisplay profile={item.Receptor} isEmisor={false} />
                    )}
                  {
                    docType === documentTypeEnum.FacturaCompra && (
                      <ProfileDisplay profile={item.Emisor} isEmisor={false} />
                    )
                  }

                  <Encabezado data={item} />

                  <Detalle detalle={item.DetalleServicio.LineaDetalle} />

                  <Container className="ui row fluid resumen-documento-container">
                    <div className="ui stackable two column grid">
                      <div className="column ten wide">
                        <div>
                          Notas adicionales:
                        </div>
                          <div>{item.Otros?.OtroTexto}</div> 
                        </div>
                      <div className="column six wide right aligned">
                        <RenderResumenDocumento ResumenFactura={item.ResumenFactura} />
                      </div>
                    </div>
                  </Container>
                  <div className={className}>
                    {item.Errores}
                  </div>
                </div>

              </Accordion.Content>
            </div>
          ))}
      </Accordion>

      <Modal
        centered={false}
        size="small"
        open={isActiveModal}
        onClose={() => setIsActiveModal(false)}
      >
        <Modal.Header>Reenviar Documento</Modal.Header>

        <Modal.Content>

          <div className="ui grid">

            <div className="sixteen wide column">
              <form className="ui form reenvio-documentos" >
                <div className={(emailError) && "field error"}>
                  <label>Correo adicional (opcional)</label>
                  <input
                    onChange={(e) => handleInputEmail(e.target.value)}
                    type="email"
                    name="email" ></input>
                  <p className="mgs-error-email"> {emailError} </p>
                </div>
              </form>
            </div>

            <div className="sixteen wide column">
              <hr className="hr-modal" />
              <div className="ui list">
                <div className="item"><strong>Nombre del cliente:</strong> {infoCliente.nombreTemp}</div>
                <div className="item"><strong>Email:</strong> {infoCliente.emailTemp}</div>
              </div>
            </div>

          </div>

        </Modal.Content>

        <Modal.Actions>
          <div style={{ textAlign: "left" }}>
            <Button negative onClick={() => setIsActiveModal(false)}>
              Cerrar
            </Button>
            <Button positive onClick={() => handleSubmit()}>
              Enviar Documento
            </Button>
          </div>
        </Modal.Actions>

      </Modal>

    </div>
  )
};


const mapStateToProps = (state) => {
  return {
    errorState: state.errorState,
    duplicarFacturaState: state.duplicarFacturaState,
    isLoading: state.isLoadingState,
  };
}

export default connect(mapStateToProps, {
  duplicarFactura,
  reenviarDocumento,
  clearErrors
})(ListadoDocumentos);